<div class="produto-mapa">
      <h3 class="title-h3">{{'Localização da Atividade' | translate}}</h3>
      <div class="maps contact-page_content_map w-widget w-widget-map" #maps></div>
</div>      